import DOMPurify from 'dompurify'

// 可配置过滤规则：根据业务扩展/删减
const FILTER_CONFIG = {
  // 基础表单过滤：需移除的危险字符
  dangerChars: /[<>&"'\\]/g,
  // 禁止的危险关键词（忽略大小写）
  dangerKeywords: ['script', 'onclick', 'onload', 'onerror', 'javascript:', 'iframe', 'embed'],
  // 富文本白名单（和v-safe-html指令保持一致，避免重复配置）
  richTextOptions: {
    ALLOWED_TAGS: ['p', 'br', 'img', 'h1', 'h2', 'strong', 'em', 'u', 'span'],
    ALLOWED_ATTR: ['src', 'alt', 'title', 'class', 'style'],
    DISALLOW_ATTR: ['on*', 'href', 'srcdoc']
  }
}

// 通用过滤工具函数：基础过滤（所有输入通用）
const baseFilter = (val) => {
  if (typeof val !== 'string' || !val) return ''
  // 1. 移除危险字符
  let result = val.replace(FILTER_CONFIG.dangerChars, '')
  // 2. 移除危险关键词（全局匹配，忽略大小写）
  FILTER_CONFIG.dangerKeywords.forEach(key => {
    const reg = new RegExp(key, 'gi')
    result = result.replace(reg, '')
  })
  return result
}

// 富文本深度过滤：基于DOMPurify，适配Element UI富文本/el-rich-text
const richTextFilter = (val) => {
  if (typeof val !== 'string' || !val) return ''
  // 先基础过滤，再深度清洗富文本
  return DOMPurify.sanitize(baseFilter(val), FILTER_CONFIG.richTextOptions)
}

export default {
  methods: {
    /**
     * 全局过滤方法：组件内可手动调用（如提交前二次过滤）
     * @param {String} val - 待过滤值
     * @param {Boolean} isRichText - 是否为富文本，默认false（基础表单）
     */
    elFilterInput(val, isRichText = false) {
      return isRichText ? richTextFilter(val) : baseFilter(val)
    }
  },
  // 自定义指令：v-el-filter - 绑定在Element UI输入组件上实现实时过滤
  directives: {
    'el-filter': {
      bind(el, binding, vnode) {
        // 兼容Element UI：找到真实的原生input/textarea元素（Element组件会封装一层）
        const inputEl = el.tagName === 'INPUT' || el.tagName === 'TEXTAREA'
          ? el
          : el.querySelector('input') || el.querySelector('textarea')

        if (!inputEl) return

        // 标记是否为富文本（指令传参：v-el-filter="true"）
        const isRichText = binding.value || false
        // 中文输入兼容：避免输入法组合键时触发重复过滤
        let isComposing = false

        // 组合键开始：停止过滤
        inputEl.addEventListener('compositionstart', () => {
          isComposing = true
        })
        // 组合键结束：执行过滤并更新值
        inputEl.addEventListener('compositionend', (e) => {
          isComposing = false
          handleInput(e)
        })
        // 实时输入过滤
        inputEl.addEventListener('input', handleInput)

        // 核心过滤处理函数
        function handleInput(e) {
          if (isComposing) return
          const target = e.target
          // 过滤值
          const filteredVal = isRichText
            ? richTextFilter(target.value)
            : baseFilter(target.value)
          // 过滤后值不同才更新，避免死循环
          if (target.value !== filteredVal) {
            target.value = filteredVal
            // 触发input事件：更新v-model绑定值（Element UI基于input事件实现v-model）
            target.dispatchEvent(new Event('input'))
            // 触发change事件：兼容Element UI的change校验/监听
            target.dispatchEvent(new Event('change'))
          }
        }

        // 指令解绑：移除事件监听，防止内存泄漏
        vnode.context.$once('hook:beforeDestroy', () => {
          inputEl.removeEventListener('compositionstart', () => { isComposing = true })
          inputEl.removeEventListener('compositionend', handleInput)
          inputEl.removeEventListener('input', handleInput)
        })
      }
    }
  }
}